import React from 'react';
import Rewards from '../Rewards';

export default function Categories() {
    return <Rewards defaultTab="categories" />;
}
